export const GET_DATA_COUNTRIES         = 'GET_DATA_COUNTRIES'
export const CREATE_UPDATE_COUNTRIES    = 'CREATE_UPDATE_COUNTRIES'
export const TYPE_UPDATE_COUNTRIES      = 'TYPE_UPDATE_COUNTRIES'
export const LOADING_COUNTRIES          = 'LOADING_COUNTRIES'